import { IPromise } from 'angular';

import { RequestHelper } from '../../ts/helpers/RequestHelper';
import { ResultHelper } from '../../ts/helpers/ResultHelper';
import { Module } from '../../ts/Module';
import { DeleteWorkbookVersionsRequest } from '../../ts/ServerApi/requests/DeleteWorkbookVersionsRequest';
import { GetWorkbookVersionsRequest, IGetWorkbookVersionsResult } from '../serverApi/requests/getWorkbookVersionsRequest';
import { IWorkbookRevision } from '../serverApi/types/IWorkbookRevision';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { ServerService } from '../../ts/services/ServerService';
import { Resource } from '../../ts/resources/Resource';

export class WorkbookRevisions extends Resource<IWorkbookRevision>  {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetWorkbookVersionsRequest,
      (result: IGetWorkbookVersionsResult) => result.versions));

    this.server = ErrorNotifyingServer.getServerService();
  }

  public del = (id: string): IPromise<IResult> => {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteWorkbookVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('WorkbookRevisions', WorkbookRevisions);
